import React from 'react';
import Layout from '../../../components/layouts/Layout';
import { useTranslation } from 'react-i18next';
import { PagesType } from '../../../types/enum/pagesType';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useSearchParams } from 'react-router-dom';
import SiteContentForm from './SiteContentForm';

export default function SiteContentPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const category = (searchParams.get("category")) || PagesType.ABOUT;

  const categories = [
    { id: PagesType.ABOUT, name: t(PagesType.ABOUT) },
    { id: PagesType.CUSTOMER_APP, name: t(PagesType.CUSTOMER_APP) },
    { id: PagesType.MERCHANT_APP, name: t(PagesType.MERCHANT_APP) },
    { id: PagesType.MERCHANT_DASHBOARD, name: t(PagesType.MERCHANT_DASHBOARD) },
    { id: PagesType.PRIVACY_POLICY, name: t(PagesType.PRIVACY_POLICY) },
    { id: PagesType.TERMS_AND_CONDITIONS, name: t(PagesType.TERMS_AND_CONDITIONS) },
  ];

  // ✅ Render content based on selected category
  const renderContent = (selectedCategory: PagesType) => {
    switch (selectedCategory) {
      case PagesType.ABOUT:
      case PagesType.CUSTOMER_APP:
      case PagesType.MERCHANT_APP:
      case PagesType.MERCHANT_DASHBOARD:
      case PagesType.PRIVACY_POLICY:
      case PagesType.TERMS_AND_CONDITIONS:
        // For all these pages, render the SiteContentForm
        return <SiteContentForm keyType={selectedCategory} />;
    }
  };

  return (
    <Layout title={t("admin_sidebar.site_content")} headline={t(category as PagesType)}>
      <CategoriesSection
        selectedCategory={category ?? ""}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={""}
        buttonLabel=''
        showAdd={false}
        notShowAddButton={true}
        showAllLable={false}
      />

      {/* Render content dynamically */}
      {renderContent(category as PagesType)}
    </Layout>
  );
}
